import React, { memo } from 'react';

interface StatCardProps {
  /** カード タイトル */
  title: string;
  /** 表示する値 */
  value: string;
  /** アイコン */
  icon: React.ReactNode;
  /** カラーテーマ（primary、secondary等） */
  color?: string;
}

/**
 * 統計カードコンポーネント
 * ダッシュボードで数値統計を表示するためのカード
 */
export const StatCard: React.FC<StatCardProps> = memo(
  ({ title, value, icon, color = 'primary' }) => (
    <div className='bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md flex items-center card-touch touch-target hover:shadow-lg transition-shadow duration-200'>
      <div className={`p-3 rounded-full bg-${color}-100 dark:bg-${color}-900/50 mr-4`}>{icon}</div>
      <div>
        <p className='text-sm text-gray-500 dark:text-gray-400'>{title}</p>
        <p className='text-2xl font-bold text-gray-800 dark:text-white'>{value}</p>
      </div>
    </div>
  )
);

StatCard.displayName = 'StatCard';
